@let view = data();

@if (view.headline) {
  <h2>{{ view.headline }}</h2>
}

@for (item of view.items; track item) {
  <ui-content-teaser
    [data]="item"
  ></ui-content-teaser>
}
